import { cn } from '../../shared/lib/cn'

export function formatCurrency(value: number, compact = false): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: compact ? 0 : 2,
    notation: compact && Math.abs(value) >= 1_000_000 ? 'compact' : 'standard',
  }).format(value)
}

export function formatPct(value: number): string {
  return `${value >= 0 ? '+' : ''}${(value * 100).toFixed(1)}%`
}

export function statusBadgeClass(status: string): string {
  return cn(
    'inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold',
    status === 'hitl'
      ? 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-300'
      : 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-950/30 dark:text-emerald-300',
  )
}

export function varianceClass(value: number): string {
  if (Math.abs(value) <= 0.3) return 'text-gray-600 dark:text-gray-300'
  return value > 0
    ? 'text-rose-600 dark:text-rose-400'
    : 'text-emerald-600 dark:text-emerald-400'
}
